var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("expired-distribution-dialog", { ref: "expiredDistributionDialog" }),
      _c("breadcrumbs", { attrs: { section: "Find Videos" } }),
      _vm.loadingComponent
        ? _c("md-progress", {
            staticClass: "md-accent",
            attrs: { "md-indeterminate": "md-indeterminate" }
          })
        : _c(
            "div",
            { staticClass: "page-container" },
            [
              _vm.showExpiredDate
                ? _c("div", { staticClass: "expiredInfo" }, [
                    _c("button", { on: { click: _vm.deadLineInfo } }, [
                      _vm._v(
                        "There are distributions or licenses that have expired or are about to expire"
                      )
                    ]),
                    _c("button", { on: { click: _vm.closeShowExpiredDate } }, [
                      _vm._v("X")
                    ])
                  ])
                : _vm._e(),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100", "md-theme": "blue" } },
                [
                  _c(
                    "md-whiteframe",
                    { staticClass: "filters-frame" },
                    [
                      _c("media-item-filters", {
                        attrs: { search: _vm.search },
                        on: {
                          getNetworksError: function($event) {
                            return _vm.showAlertToast($event, "error")
                          },
                          goSearch: _vm.updateQueryAndSearch,
                          cleanSearch: _vm.cleanInputs
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { staticClass: "content-frame", attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "25" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "playlist-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("playlists", {
                            on: {
                              error: function($event) {
                                return _vm.showAlertToast($event, "error")
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { staticClass: "margin-top", attrs: { "md-flex": "75" } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-column": "" } },
                        [
                          _c(
                            "md-layout",
                            { attrs: { "md-flex": "100" } },
                            [
                              _c(
                                "stitch-loader",
                                { attrs: { loading: _vm.searching, size: 45 } },
                                [
                                  _c(
                                    "md-layout",
                                    {
                                      attrs: {
                                        id: "cards-index-container",
                                        "md-gutter": 16,
                                        "md-align": "center"
                                      }
                                    },
                                    _vm._l(_vm.searchResults, function(item) {
                                      return _c(
                                        "md-layout",
                                        {
                                          key: item._id,
                                          staticClass: "media-row",
                                          attrs: {
                                            id: "item-card-index-container",
                                            "md-flex-xsmall": "100",
                                            "md-flex-small": "50",
                                            "md-flex-medium": "30",
                                            "md-flex-large": "30",
                                            "md-flex-xlarge": "30"
                                          }
                                        },
                                        [
                                          _c("stitch-media-item", {
                                            staticClass: "marketplaceTitle",
                                            attrs: { item: item },
                                            on: {
                                              addToPlaylistError: function(
                                                $event
                                              ) {
                                                return _vm.showAlertToast(
                                                  $event,
                                                  "error"
                                                )
                                              },
                                              removeFromPlaylistError: function(
                                                $event
                                              ) {
                                                return _vm.showAlertToast(
                                                  $event,
                                                  "error"
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                  _c(
                                    "md-layout",
                                    {
                                      staticClass: "spinnerBlock",
                                      attrs: {
                                        "md-align": "center",
                                        id: "loaderLayout"
                                      }
                                    },
                                    [
                                      _c(
                                        "infinite-loading",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.totalItemsForSearch > 20,
                                              expression:
                                                "totalItemsForSearch > 20"
                                            }
                                          ],
                                          attrs: {
                                            identifier: _vm.resetIdentifier
                                          },
                                          on: { infinite: _vm.loadMoreResults }
                                        },
                                        [
                                          _c("md-spinner", {
                                            staticClass: "md-accent",
                                            attrs: {
                                              slot: "spinner",
                                              "md-indeterminate":
                                                "md-indeterminate",
                                              "md-size": 60
                                            },
                                            slot: "spinner"
                                          }),
                                          _c("span", {
                                            attrs: { slot: "no-more" },
                                            slot: "no-more"
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.totalItemsForSearch === 0
                                    ? _c(
                                        "div",
                                        { attrs: { id: "no-results" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "second" },
                                            [
                                              _c("md-icon", {
                                                staticClass: "md-accent",
                                                attrs: {
                                                  "md-iconset":
                                                    "fa fa-exclamation-circle"
                                                }
                                              }),
                                              _vm._v("No items to show")
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5006ae4c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5006ae4c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/marketplace/index.vue
// module id = 692
// module chunks = 0